import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {
  Form,
  Button,
  Modal,
  Icon,
  Message,
  Select,
  Checkbox,
} from 'semantic-ui-react';
import { isEmpty, compact } from 'lodash';
import Validator from 'validatorjs';
import MaskedInput from 'react-text-mask';
import { utcMoment } from '../../utilities/dateUtils';
import subscriptionProductTypeQuery from '../../graphql/subscriptionProductTypeQuery';
import client from '../../apollo';
import { MULTI_SUBSCRIPTION_ENABLED } from '../../config';
import {
  SA_PRODUCT_CODE,
  BUYER_SUBSCRIPTION_TYPE,
  SELLER_SUBSCRIPTION_TYPE,
} from '../../constants/subscriptions';

const headerStyle = {
  display: 'grid',
  justifyContent: 'space-between',
  gridTemplateColumns: 'auto auto',
};

class SubscriptionNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: null,
      productName: '',
      productCode: '',
      subscriptionType: '',
      priceDs: null,
      pricePsiLpi: null,
      notifyEmail: '',
      startDate: utcMoment(moment(new Date()).add(1, 'days')),
      endDate: null,
      productTypes: [],
      errors: {},
      dsPaidPsi: true,
    };
  }

  onSelectHandler = field => (event, data) => {
    event.preventDefault();

    const selectedOption = data.options.find(o => o.value === data.value);
    const { key } = selectedOption;
    const selectedProductCode = selectedOption.productCode || '';
    this.setState({
      [field]: data.value,
      productId: key,
      productCode: selectedProductCode,
      pricePsiLpi: null,
      ...(MULTI_SUBSCRIPTION_ENABLED && selectedProductCode === SA_PRODUCT_CODE && { dsPaidPsi: false }),
    });
  };

  onNumberChangeHandler = field => e => {
    const REGEX_NUMBER = /^[0-9\b]+$/i;

    if (REGEX_NUMBER.test(e.target.value) || isEmpty(e.target.value)) {
      this.setState({ [field]: e.target.value, errors: { [field]: '' } });
      return true;
    }
    this.setState({
      [field]: e.target.value,
      errors: { [field]: 'Invalid format number' },
    });
    return false;
  };

  onEmailChangeHandler = field => event => {
    this.setState({ [field]: event.target.value });
  };

  validationRules = {
    priceDs: 'required|numeric',
    productName: 'required|string',
    pricePsiLpi: 'numeric',
    notifyEmail: 'required',
    startDate: 'required',
  };

  componentDidMount() {
    this.getProductTypesQuery();
  }

  getProductTypesQuery = () => {
    const { existingSubscriptionTypes } = this.props;
    client
      .query({
        query: subscriptionProductTypeQuery,
      })
      .then(({ data }) => {
        const { subscriptionProductType: allProductTypes } = data;
        let productTypes = allProductTypes;
        if (MULTI_SUBSCRIPTION_ENABLED) {
          const hasBuyer = existingSubscriptionTypes.includes(BUYER_SUBSCRIPTION_TYPE);
          const hasSeller = existingSubscriptionTypes.includes(SELLER_SUBSCRIPTION_TYPE);
          productTypes = allProductTypes.filter(pt => {
            if (hasSeller && pt.productCode === SA_PRODUCT_CODE) return false;
            if (hasBuyer && pt.productCode !== SA_PRODUCT_CODE) return false;
            return true;
          });
        }
        this.setState({ productTypes });
      })
      .catch(() => {
        // console.log('Error: ', error);
      });
  };

  static validateStartDateField(field = 'startDate', value = undefined) {
    let startDate = value;
    startDate = moment(new Date(startDate)).format('YYYY-MM-DD');
    const currentDate = moment(new Date()).format('YYYY-MM-DD');

    if (isEmpty(startDate) && field === 'startDate') {
      return 'This field is required';
    }

    if (
      moment(value).isValid() === false
      && startDate === 'Invalid date'
      && !isEmpty(value)
    ) {
      return 'Please input with a correct format value of YYYY-MM-DD';
    }

    if (
      !isEmpty(startDate)
      && field === 'startDate'
      && moment(new Date(startDate)) > moment(new Date()).add(30, 'days')
    ) {
      return 'Please enter date should be older than 30 days';
    }

    if (
      !isEmpty(startDate)
      && field === 'startDate'
      && startDate <= currentDate
    ) {
      return 'Please enter date in a future date (Tomorrow day)';
    }

    return '';
  }

  static validateEndDateField(field = 'endDate', value = undefined, startDate = undefined) {
    let endDate = value;
    const startD = moment(new Date(startDate)).format('YYYY-MM-DD');

    endDate = moment(new Date(endDate)).format('YYYY-MM-DD');

    if (
      moment(value).isValid() === false
      && endDate === 'Invalid date'
      && !isEmpty(value)
    ) {
      return 'Please input with a correct format value of YYYY-MM-DD';
    }

    if (isEmpty(endDate) && field === 'endDate') {
      return '';
    }

    if (
      !isEmpty(startD)
      && !isEmpty(endDate)
      && field === 'endDate'
      && moment(new Date(endDate)) <= moment(new Date(startD))
    ) {
      return 'End Date cannot be less equal than Start Date';
    }

    return '';
  }

  showMsgValidationDate = (field, value) => {
    let msg = '';

    if (field === 'startDate') {
      msg = SubscriptionNew.validateStartDateField(field, value);
    }

    const { startDate } = this.state;
    if (field === 'endDate') {
      msg = SubscriptionNew.validateEndDateField(field, value, startDate);
    }

    return msg;
  };

  onDateChangeHandler = field => date => {
    this.setState({
      [field]:
        !isEmpty(date)
        && moment(date).isValid()
        && moment(new Date(date._d)).format('YYYY-MM-DD'),
      errors: {
        [field]: '',
      },
    });
  };

  onDateFocusHandler = field => event => {
    if (!event) return;
    const val = event.target.value;

    const { endDate } = this.state;

    if (
      field === 'startDate'
      && moment(new Date(val)) >= moment(new Date(endDate))
    ) {
      this.setState({
        startDate: val,
        endDate: '',
        errors: {
          startDate: '',
        },
      });
      return;
    }

    const msg = this.showMsgValidationDate(field, val);

    this.setState({
      [field]: val,
      errors: {
        [field]: msg,
      },
    });
  };

  onCheckboxHandler = field => (event, data) => {
    this.setState({ [field]: data.checked });
  };

  static isNonBundleProduct(prdName) {
    const productName = prdName.toLowerCase();
    return (
      productName === 'dealshield 21-day'
      || productName === 'dealshield 30-day'
      || productName === 'dealshield select 21-day'
      || productName === 'dealshield select 30-day'
    );
  }

  handleSubmit = () => {
    const {
      productId,
      productName,
      productCode,
      subscriptionType,
      priceDs,
      notifyEmail,
      dsPaidPsi,
    } = this.state;

    let {
      pricePsiLpi,
      startDate,
      endDate,
    } = this.state;

    const { onSubmitHandler, subscription } = this.props;

    const REGEX_DATE = /[0-9]{4}-(0?[1-9]|1[012])-(0[0-9]|[12][0-9]|3[01])/i;

    if (
      moment(startDate._d) === 'Invalid Date'
      && REGEX_DATE.test(startDate) === false
      && !isEmpty(startDate)
    ) {
      this.setState({
        errors: {
          startDate: 'Please input with a correct format value of YYYY-MM-DD',
        },
      });
      return false;
    }

    if (
      moment(endDate) === 'Invalid Date'
      && REGEX_DATE.test(endDate) === false
      && !isEmpty(endDate)
    ) {
      this.setState({
        errors: {
          endDate: 'Please input with a correct format value of YYYY-MM-DD',
        },
      });
      return false;
    }

    if (isEmpty(startDate)) {
      startDate = '';
    } else {
      const parsedStartDate = moment(new Date(startDate));
      startDate = parsedStartDate.isValid()
        ? parsedStartDate.format('YYYY-MM-DD')
        : 'Invalid Date';
    }

    if (isEmpty(endDate)) {
      endDate = '';
    } else {
      const parsedEndDate = moment(new Date(endDate));
      endDate = parsedEndDate.isValid()
        ? parsedEndDate.format('YYYY-MM-DD')
        : 'Invalid Date';
    }

    const REGEX_MULTIPLE_EMAILS = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})((,| ,|, | , |;| ;|; | ; |){1}[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i;
    const REGEX_EMAIL_SEPARATES = /(?:,)|(?:;)|(\s)/g;
    const formatNotifyEmail = compact(
      notifyEmail.split(REGEX_EMAIL_SEPARATES)
    )
      .map(email => email.replaceAll(' ', ''))
      .filter(Boolean)
      .join(',');

    const validation = new Validator(this.state, this.validationRules, {
      'required.productName': 'This field is required',
      'required.priceDs': 'This field is required',
      'required.notifyEmail': 'This field is required',
      'required.startDate': 'This field is required',
    });

    if (moment(new Date(startDate)) > moment(new Date()).add(30, 'days')) {
      this.setState({
        errors: {
          startDate: 'Please enter date should be older than 30 days',
        },
      });
      return false;
    }

    if (
      !isEmpty(startDate)
      && moment(new Date(startDate)) <= moment(new Date())
    ) {
      this.setState({
        errors: {
          startDate: 'Please enter date in a future date (Tomorrow day)',
        },
      });
      return false;
    }

    if (
      !isEmpty(startDate)
      && !isEmpty(endDate)
      && moment(new Date(endDate)) <= moment(new Date(startDate))
    ) {
      this.setState({
        endDate: moment(new Date(endDate)).format('YYYY-MM-DD'),
        errors: {
          endDate: 'End Date cannot be less equal than Start Date',
        },
      });
      return false;
    }

    if (parseFloat(priceDs) !== 0 && parseFloat(priceDs) < 1) {
      this.setState({
        errors: {
          priceDs:
            'Please input with a correct Dealshield price (0 or from 1 to 999)',
        },
      });
      return false;
    }

    if (
      !isEmpty(`${pricePsiLpi}`)
      && parseFloat(pricePsiLpi) !== 0
      && parseFloat(pricePsiLpi) < 1
    ) {
      this.setState({
        errors: {
          pricePsiLpi:
            'Please input with a correct PSI/LPI price (0 or from 1 to 999)',
        },
      });
      return false;
    }

    if (validation.fails()) {
      this.setState({ ...validation.errors });
      return false;
    }

    if (!REGEX_MULTIPLE_EMAILS.test(notifyEmail)) {
      this.setState({
        errors: {
          notifyEmail:
            'Invalid email format. If using multi email e.g. user1@gmail.com,user2@gmail.com,...',
        },
      });
      return false;
    }

    pricePsiLpi = SubscriptionNew.isNonBundleProduct(productName) ? 0 : pricePsiLpi;

    const resolveSubscriptionType = () => {
      if (MULTI_SUBSCRIPTION_ENABLED && productCode === SA_PRODUCT_CODE) {
        return SELLER_SUBSCRIPTION_TYPE;
      }
      return subscriptionType || BUYER_SUBSCRIPTION_TYPE;
    };

    onSubmitHandler({
      dealerName: subscription[0].dealerName,
      dealerNumber: parseInt(subscription[0].dealerNumber, 10),
      productId: parseInt(productId, 10),
      productName,
      subscriptionType: resolveSubscriptionType(),
      priceDs: parseFloat(priceDs),
      pricePsiLpi: parseFloat(pricePsiLpi),
      notifyEmail: formatNotifyEmail || '',
      startDate,
      endDate,
      active: true,
      sameDayPriceUpdate: false,
      subscription,
      dsPaidPsi,
    });
    return true;
  };

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      submitting,
      error,
      onOpenConfirmationPopup,
      onCloseConfirmationPopup,
      onContinueCreateSubscription,
      isConfirmationPopup,
      dealerInfo,
    } = this.props;

    const {
      productId,
      productName,
      productCode,
      priceDs,
      pricePsiLpi,
      notifyEmail,
      startDate,
      endDate,
      dsPaidPsi,
      productTypes,
      errors,
    } = this.state;

    const bundlePricePsiLpi = prodName => {
      return SubscriptionNew.isNonBundleProduct(prodName) ? '' : pricePsiLpi;
    };

    return (
      <div>
        {isModalOpen && (
          <Modal
            open={isModalOpen}
            closeIcon
            onClose={onCloseHandler}
            closeOnEscape={false}
            closeOnRootNodeClick={false}
          >
            <Modal.Header style={headerStyle}>
              <span>Create new subscription</span>
              <span>{dealerInfo}</span>
            </Modal.Header>
            <Modal.Content image scrolling>
              <Modal.Description>
                {error && (
                  <Message negative>
                    <p>{error}</p>
                  </Message>
                )}
                <Form>
                  <Form.Group widths='equal'>
                    <Form.Field required error={!isEmpty(errors.productName)}>
                      <label htmlFor='productName'>DealShield Product Selection</label>
                      <Select
                        id='productName'
                        placeholder='Select DealShield Product'
                        options={productTypes}
                        closeOnBlur
                        value={productName}
                        key={productId}
                        onChange={this.onSelectHandler('productName')}
                        style={{ width: '50%' }}
                      />
                      {errors.productName && (
                        <div style={{ color: 'red' }}>{errors.productName}</div>
                      )}
                    </Form.Field>
                  </Form.Group>
                  <Form.Group>
                    <Form.Field required error={!isEmpty(errors.priceDs)}>
                      <label htmlFor='priceDs'>DealShield Price</label>
                      <input
                        id='priceDs'
                        name='priceDs'
                        value={priceDs}
                        onChange={this.onNumberChangeHandler('priceDs')}
                        placeholder='N/A'
                        type='text'
                        pattern='\d*'
                        maxLength='3'
                      />
                      {errors.priceDs && (
                        <div style={{ color: 'red' }}>{errors.priceDs}</div>
                      )}
                    </Form.Field>

                    <Form.Field error={!isEmpty(errors.pricePsiLpi)}>
                      <label htmlFor='pricePsiLpi'>DealShield PSI / LPI Price</label>
                      <input
                        id='pricePsiLpi'
                        name='pricePsiLpi'
                        value={bundlePricePsiLpi(productName)}
                        onChange={this.onNumberChangeHandler('pricePsiLpi')}
                        placeholder='N/A'
                        type='text'
                        pattern='\d*'
                        maxLength='3'
                        disabled={SubscriptionNew.isNonBundleProduct(productName)}
                      />
                      {errors.pricePsiLpi && (
                        <div style={{ color: 'red' }}>{errors.pricePsiLpi}</div>
                      )}
                    </Form.Field>
                  </Form.Group>

                  <Form.Group>
                    <Form.Field
                      style={{ width: '50%' }}
                      required
                      error={!isEmpty(errors.notifyEmail)}
                    >
                      <label htmlFor='notifyEmail'>POC Email Address</label>
                      <input
                        id='notifyEmail'
                        name='notifyEmail'
                        placeholder='Please input email'
                        value={notifyEmail}
                        onChange={this.onEmailChangeHandler('notifyEmail')}
                      />
                      {errors.notifyEmail && (
                        <div style={{ color: 'red' }}>{errors.notifyEmail}</div>
                      )}
                    </Form.Field>
                  </Form.Group>

                  <Form.Group>
                    <Form.Field required error={!isEmpty(errors.startDate)}>
                      <label htmlFor='startDate'>Subscription Start Date</label>
                      <DatePicker
                        id='startDate'
                        style={{ padding: '0', width: '100%' }}
                        selected={
                          !isEmpty(startDate) && moment(startDate).isValid()
                            ? moment(startDate)
                            : moment(new Date()).add(1, 'days')
                        }
                        minDate={moment(new Date(), 'YYYY-MM-DD').add(
                          1,
                          'days'
                        )}
                        maxDate={moment(new Date(), 'YYYY-MM-DD').add(
                          29,
                          'days'
                        )}
                        onChange={this.onDateChangeHandler('startDate')}
                        onBlur={this.onDateFocusHandler('startDate')}
                        dateFormat='YYYY-MM-DD'
                        maxlength='10'
                        popperPlacement='bottom-start'
                        popperProps={{ positionFixed: true }}
                        customInput={(
                          <MaskedInput
                            mask={[
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              '/',
                              /\d/,
                              /\d/,
                              '/',
                              /\d/,
                              /\d/,
                            ]}
                            keepCharPositions
                            guide
                          />
                        )}
                      />
                      {errors.startDate && (
                        <div style={{ color: 'red' }}>{errors.startDate}</div>
                      )}
                    </Form.Field>

                    <Form.Field error={!isEmpty(errors.endDate)}>
                      <label htmlFor='endDate'>Subscription End Date</label>
                      <DatePicker
                        id='endDate'
                        style={{ padding: '0', width: '100%' }}
                        selected={
                          !isEmpty(endDate) && moment(endDate).isValid()
                            ? moment(endDate)
                            : null
                        }
                        minDate={moment(
                          new Date(startDate),
                          'YYYY-MM-DD ZZ'
                        ).add(1, 'days')}
                        maxDate={moment(
                          new Date(startDate),
                          'YYYY-MM-DD ZZ'
                        ).add(29, 'days')}
                        onChange={this.onDateChangeHandler('endDate')}
                        onBlur={this.onDateFocusHandler('endDate')}
                        dateFormat='YYYY-MM-DD'
                        maxlength='10'
                        popperPlacement='bottom-start'
                        popperProps={{ positionFixed: true }}
                        customInput={(
                          <MaskedInput
                            mask={[
                              /\d/,
                              /\d/,
                              /\d/,
                              /\d/,
                              '/',
                              /\d/,
                              /\d/,
                              '/',
                              /\d/,
                              /\d/,
                            ]}
                            keepCharPositions
                            guide
                          />
                        )}
                      />
                      {errors.endDate && (
                        <div style={{ color: 'red' }}>{errors.endDate}</div>
                      )}
                    </Form.Field>
                    {(!MULTI_SUBSCRIPTION_ENABLED || productCode !== SA_PRODUCT_CODE) && (
                      <Form.Field>
                        <label htmlFor='dsPaidPsi'>DS Paid PSI</label>
                        <Checkbox
                          id='dsPaidPsi'
                          checked={dsPaidPsi}
                          onChange={this.onCheckboxHandler('dsPaidPsi')}
                        />
                      </Form.Field>
                    )}
                  </Form.Group>
                </Form>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              {!submitting && (
                <Button color='green' onClick={this.handleSubmit} inverted>
                  <Icon name='checkmark' /> Create
                </Button>
              )}
              <Button onClick={onCloseHandler}>Cancel</Button>
            </Modal.Actions>
          </Modal>
        )}
        <div>
          {onOpenConfirmationPopup && isConfirmationPopup && (
            <Modal
              open={onOpenConfirmationPopup}
              closeIcon
              onClose={onCloseConfirmationPopup}
              closeOnEscape={false}
              closeOnRootNodeClick={false}
            >
              <Modal.Header style={headerStyle}>
                <span>Create new subscription</span>
                <span>{dealerInfo}</span>
              </Modal.Header>
              <Modal.Content image scrolling>
                <Modal.Description>
                  <p>
                    {' '}
                    There is an active subscription for this dealer. If a new
                    subscription is created, the existing subscription will
                    automatically be expired today. The new subscription will be
                    valid from tomorrow.
                    <br />
                    Do you want to process?
                  </p>
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button color='green' onClick={onContinueCreateSubscription}>
                  <Icon name='checkmark' />
                  Continue.
                </Button>
                <Button onClick={onCloseConfirmationPopup}>Cancel</Button>
              </Modal.Actions>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}

SubscriptionNew.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  subscription: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.string,
  onOpenConfirmationPopup: PropTypes.bool,
  onCloseConfirmationPopup: PropTypes.func.isRequired,
  onContinueCreateSubscription: PropTypes.func.isRequired,
  isConfirmationPopup: PropTypes.bool,
  dealerInfo: PropTypes.string,
  existingSubscriptionTypes: PropTypes.arrayOf(PropTypes.string),
};

SubscriptionNew.defaultProps = {
  isModalOpen: false,
  submitting: false,
  subscription: [],
  error: null,
  onOpenConfirmationPopup: false,
  isConfirmationPopup: false,
  dealerInfo: '',
  existingSubscriptionTypes: [],
};

export default SubscriptionNew;
